/** Лимит заметки к названию проекта и к имени чтеца в каталоге (сервер VARCHAR(40)) */
export const MAX_NAME_NOTE_LEN = 40;

/** Верхняя граница авто-высоты textarea заметки */
export const NAME_NOTE_TEXTAREA_MAX_ROWS = 12;

/** Одна строка: переводы строк → пробел, trim. */
export function nameNoteSingleLine(raw: string | null | undefined): string {
  return String(raw ?? '')
    .replace(/\r\n|\r|\n/g, ' ')
    .trim();
}
